// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"9fe820a9","992":"84b5d456"}[chunkId] + ".chunk.css";
};